export default {
  getCompanyReports: 'GET_COMPANY_REPORTS',
  getCompanyReportsSuccess: 'GET_COMPANY_REPORTS_SUCCESS',
  getCompanyReportsFailed: 'GET_COMPANY_REPORTS_FAILED',
};
